// extracted by mini-css-extract-plugin
module.exports = {"root":"PackagesBreadcrumbs_root__1W76c","breadcrumbLink":"PackagesBreadcrumbs_breadcrumbLink__2MfGx","statusTitle":"PackagesBreadcrumbs_statusTitle__3hkga"};